<!--
  A broadcast timecode. Tabular figures, so the digits do not shift as it counts.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { formatTimecode } from '../onair.js';

const props = withDefaults(
  defineProps<{ ms: number; size?: 'large' | 'inline'; label?: string }>(),
  { size: 'inline' },
);

const text = computed(() => formatTimecode(props.ms));
</script>

<template>
  <span :class="size === 'large' ? 'shio-timecode' : 'shio-numeric'">
    <span v-if="label" class="shio-sr-only">{{ label }}: </span>{{ text }}
  </span>
</template>
